/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Zrušit výběr',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Načtení dat se nezdařilo.',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Kliknutím opakovat',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Načítání…',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Zobrazit více',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} z {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nebyly nalezeny žádné shody',
  'paginated-picker.async-select.select.option.error-message': 'Načtení dat se nezdařilo.',
  'paginated-picker.async-select.select.option.retry-message': 'Kliknutím opakovat',
  'paginated-picker.async-select.select.search-placeholder': 'Vyhledat',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Zobrazit úplný seznam'
};